// @flow
import Main from './Main'
import Statement from './Statement'
import EditSubaccount from './EditSubaccount'

export default ((store: Object) => ({
  path: 'subaccounts/:subnumber',
  children: [
    {
      element: <Main />,
      index: true,
    },
    {
      element: <Statement />,
      path: 'statement',
    },
    {
      element: <EditSubaccount />,
      path: 'edit',
    },
  ],
}))()
